import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { AddSubject } from "./Modal/AddSubject";
// import { EditSubject } from "./Modal/EditSubject";
import Switch from '@mui/material/Switch';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { Edit } from "@mui/icons-material";
import SearchableDropdown from "../Common/SearchableDropdown";
import { DataTableComp } from "../Common/DataTable";
import { useEffect, useState } from "react";
import axios from "axios";

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

export default function Subjects() {
    const authUser = localStorage.getItem('FF-authUser');
    const user = JSON.parse(authUser);
    const navigate = useNavigate();
    const [organizations, setOrganizations] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [editId, setEditId] = useState(0);
    const [popupType, setPopupType] = useState('Add');

    const [show, setShow] = useState(false);
    useEffect(() => {
        getOrganizations()
        getSubjects()
    }, [])

    const getOrganizations = () => {
        axios.get(`/api/users?role=Organization&parentId=${user.id}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){                
                let orgList = []
                for(let i=0; i < result.data.length; i++){
                    orgList.push({name: result.data[i].name, id: result.data[i].id})
                }
                // console.log("orgList",orgList);
                setOrganizations(orgList)
            }
        })
    }

    const getSubjects = (organizationId = '') => {
        axios.get(`/api/subjects?organizationId=${organizationId}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                // console.log("orgList",orgList);
                setSubjects(result.data)
            }
        })
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.delete(`/api/subjects/delete?id=${id}`).then((res) =>{
                    if(res.data.success){                             
                        Swal.fire('Deleted!', '', 'success')
                        getSubjects();
                    } 
                }).catch((error) => {
                    console.log(error);                     
                    Swal.fire(error.message, '', 'info')           
                });
            } else if (result.isDenied) {
              Swal.fire('Cancelled!', '', 'info')
            }
        }) 
    }

    const handleAdd = () => {
        setEditId(0);
        setPopupType('Add');
        setShow(true);
    }
    const handleEdit = (id) => {
        setEditId(id);
        setPopupType('Edit');
        setShow(true);
    }

    const columns = [
        {
            name: 'Organization Name',
            selector: row => row.organization.name,
            sortable: true,
            width: "20%"
        },
        {
            name: 'Subject Name',
            cell: row => (
                <Link to={`/send_assessment?s=${row.id}`}>{row.name}</Link>
            ),
            sortable: true,
            width: "18%"
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            width: "22%"
        },
        {
            name: 'Preferred Pronoun',
            selector: row => row.preferredPronoun,
            sortable: true
        },
        // {
        //     name: 'Status',
        //     cell: row => (
        //        <Switch className="Rj-toggle" {...label} defaultChecked color="info" />                
        //     ),
        //     wrap: true
        // },
        {
            name: 'Action',
            wrap: true,
            cell: row => (
                <>
                    <Tooltip data-bs-toggle="modal" data-bs-target="#addSubject" title="Edit" size='small' className='icon icon-sm icon-secondary' onClick={() => handleEdit(row.id)}>
                        <IconButton>
                             <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick={() => handleDelete(row.id)} title="Delete" size='small' className='icon icon-sm icon-primary ms-2'>
                        <IconButton>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </>
                
            )
        },
    ];

    const handleChangeOrg = (event, value) => {
        // console.log("Autocomplete value",value)
        if(value && value.id){
            getSubjects(value.id)
        }
        else{
            getSubjects()
        }
    }

    return(
        <Layout>
            <Header pageTitle="Organizations" />
            <div className="container-xxl flex-grow-1 container-p-y">            
                <div className="">
                    <div className="card-header ">
                        <div className="row align-items-center">                    
                            <div className="col-lg-7 col-md-4 col-xs-12 mb-Rg-3">
                                <h3 className="fw-bold mb-0">Subjects</h3>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-4 col-xs-12 text-end mb-Rg-3">                                
                                <Autocomplete
                                    id="combo-box-demo"
                                    sx={{ width: 'auto' }}
                                    size='small'
                                    options={organizations}
                                    getOptionLabel={(option) => option.name}
                                    onChange={handleChangeOrg}
                                    // value={selectedOption}
                                    renderInput={(params) => <TextField {...params} label={"Select Organization"} />}
                                    
                                />
                            </div>                                
                            <div className="col-lg-2 col-md-4 col-sm-12 col-xs-12 text-md-end">                                
                                    <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addSubject"  onClick={handleAdd}>
                                    <span className="tf-icons bx bx-plus"></span>&nbsp; Add Subject
                                </button>                               
                            </div>                           
                        </div>                        
                    </div>
                    <div className="table text-nowrap">
                        <div className="">
                            <DataTableComp columns={columns} data={subjects} isIndex={true} />                            
                        </div>
                    </div>
                </div>
            </div>
            <AddSubject editId={editId} setEditId={setEditId} organizations={organizations} getSubjects={getSubjects} type={popupType} show={show} setShow={setShow}/>                   
            {/* <EditSubject /> */}
        </Layout>
    )
}